import './millennium/style';
import FormStructure from './millennium/form_structure';

export default FormStructure;